import { Navigate, useLocation } from "react-router-dom"
import { portalService } from "@/services/portal"

interface PortalProtectedRouteProps {
  children: React.ReactNode
}

export function PortalProtectedRoute({ children }: PortalProtectedRouteProps) {
  const location = useLocation()
  const learner = portalService.getCurrentLearner()

  if (!learner) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
